import { render, staticRenderFns } from "./open-card.vue?vue&type=template&id=a9201d64&scoped=true&lang=pug"
import script from "./open-card.vue?vue&type=script&lang=ts"
export * from "./open-card.vue?vue&type=script&lang=ts"
import style0 from "./open-card.vue?vue&type=style&index=0&id=a9201d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9201d64",
  null
  
)

export default component.exports